import React from 'react';
import { Flame, PauseCircle, Phone, Mail } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function SubscriptionPaused() {
  const { company, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      {/* Logo */}
      <div className="flex items-center gap-2 mb-8">
        <div className="w-9 h-9 bg-black rounded-sm flex items-center justify-center">
          <Flame size={18} className="text-white" strokeWidth={2.5} />
        </div>
        <span className="font-black text-lg tracking-tight">VAYUSARTHI</span>
      </div>

      <div className="bg-white border border-gray-200 rounded-2xl p-10 max-w-md w-full text-center shadow-sm">
        <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-5">
          <PauseCircle size={28} className="text-orange-500" />
        </div>

        <h1 className="font-black text-2xl tracking-tight mb-2">Access Paused</h1>
        <p className="text-gray-500 text-sm mb-2">
          Your company <span className="font-semibold text-gray-800">{company?.name}</span> currently has its access paused.
        </p>
        <p className="text-gray-400 text-sm mb-6">
          Please contact the platform administrator to restore access.
        </p>

        {/* Contact info */}
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-6 space-y-2">
          <div className="small-label text-gray-400 mb-2">Contact Support</div>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
            <Mail size={14} className="text-gray-400" />
            <span>support@lpgmanager.com</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
            <Phone size={14} className="text-gray-400" />
            <span>+91 98000 00000</span>
          </div>
        </div>

        <button
          onClick={logout}
          className="btn-secondary w-full text-sm"
        >
          Sign out
        </button>
      </div>

      <p className="mt-6 text-xs text-gray-400">
        Company code: <span className="font-mono font-semibold text-gray-600">{company?.code}</span>
      </p>
    </div>
  );
}
